import React from "react";
import { Paper, Text, Stack } from "@mantine/core";

function PrizeLockerTab() {
  return (
    <Paper p="xl" withBorder>
      <Stack align="center" spacing="md">
        <Text size="xl">🏆</Text>
        <Text size="lg" fw={600}>
          Prize Locker
        </Text>
        <Text size="sm" c="dimmed" ta="center">
          Your earned prizes and rewards will appear here.
        </Text>
        <Text size="xs" c="dimmed" ta="center" style={{ maxWidth: 400 }}>
          Complete incentive challenges to unlock prizes and track your
          achievements!
        </Text>
      </Stack>
    </Paper>
  );
}

export default PrizeLockerTab;
